<template>
  <div class="view-layout">
    <m-scrollbar>
      <div class="profile-boards">
        <profile />
        <password-change />
      </div>
    </m-scrollbar>
  </div>
</template>

<script>
import MScrollbar from '@/components/MScrollbar'
import Profile from '@/components/account/profile/Profile'
import PasswordChange from '@/components/account/profile/PasswordChange'

export default {
  components: {
    MScrollbar,
    Profile,
    PasswordChange
  },
  mounted () {
    this.dispatchGetting()
  },
  watch: {
    '$i18n.locale' (to, from) {
      this.dispatchGetting()
    }
  },
  methods: {
    dispatchGetting () {
      this.$store.dispatch('account/GET_PROFILE')
    }
  }
}
</script>

<style scoped>
.view-layout { height: 100%; }
.content-widget-head { margin: 0 10px; }

.profile-boards { display: flex; flex-wrap: wrap; margin: 10px; }
.profile-boards .board:nth-child(odd) { width: 50%; }
.profile-boards .board:nth-child(even) { flex: 1; margin-left: 1px; }
.profile-boards .board:not(:first-child) { margin-top: 1px; }
.profile-boards .board:first-child { border-top-left-radius: 5px; }
.profile-boards .board:nth-child(2) { border-top-right-radius: 5px; margin-top: 0; }
.profile-boards .board:nth-last-child(2) { border-bottom-left-radius: 5px; }
.profile-boards .board:last-child { border-bottom-right-radius: 5px; }
</style>



// WEBPACK FOOTER //
// src/components/account/profile/View.vue